import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useFAQDocumentDetails } from "@modules/ECMS/MAGP/Forms/FAQ/Faq.hook";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { useHyperLinkPopUp } from "../Home.hook";
import { fields } from "../constants";

export const AddEditHyperlink = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editFaq,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditFaq,
  } = useHyperLinkPopUp(query.get("editId") || "");

  const {
    data: FaqById,
    isLoading: isLoadingFaq,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditFaq();
    }
  }, [query.get("editId"), query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
        field_hyperlink_name_en: FaqById
            ? decodeHTML(FaqById.payload.field_hyperlink_name_en)
            : editFaq
            ? decodeHTML(editFaq?.[0]?.field_hyperlink_name_en)
            : "",
        field_hyperlink_name_ms: FaqById ? decodeHTML(FaqById.payload.field_hyperlink_name_ms) : editFaq ? decodeHTML(editFaq?.[0]?.field_hyperlink_name_ms) : "",
        field_hyperlink_name_zh: FaqById
            ? decodeHTML(FaqById.payload.field_hyperlink_name_zh)
            : editFaq
            ? decodeHTML(editFaq?.[0]?.field_hyperlink_name_zh)
            : "",
        field_hyperlink_description_en: FaqById
            ? decodeHTML(FaqById.payload.field_hyperlink_description_en?.value)
            : editFaq
            ? decodeHTML(editFaq?.[0]?.field_hyperlink_description_en)
            : "",
        field_hyperlink_description_ms: FaqById ? decodeHTML(FaqById.payload.field_hyperlink_description_ms?.value) : editFaq ? decodeHTML(editFaq?.[0]?.field_hyperlink_description_ms) : "",
        field_hyperlink_description_zh: FaqById
            ? decodeHTML(FaqById.payload.field_hyperlink_description_zh?.value)
            : editFaq
            ? decodeHTML(editFaq?.[0]?.field_hyperlink_description_zh)
            : "",
        field_hyperlink_published: FaqById ? decodeHTML(FaqById?.payload?.field_hyperlink_published) : decodeHTML(editFaq?.[0]?.field_hyperlink_published),
        field_module: FaqById ? decodeHTML(FaqById?.payload?.field_module) : decodeHTML(editFaq?.[0]?.field_module),
        field_sub_module: FaqById ? decodeHTML(FaqById?.payload?.field_sub_module) : decodeHTML(editFaq?.[0]?.field_sub_module),
         
    },
    fields: fields.hyperLinkPopUp,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    let descKeys: any = [
      "field_hyperlink_description_zh",
      "field_hyperlink_description_ms",
      "field_hyperlink_description_en",
    ];
    for (const key of descKeys) {
      try {
        data[key] = {
          value: data[key] || "",
          format: "full_html",
        };
      } catch (error) {}
    }

    let publishKey: any=[
      'published',
      'field_hyperlink_published'
    ]
    for (const key of publishKey) {
      data[key] = !!data[key];
    } 

    const payload = {
      action: action,
      method: method,
      module: "Manual",
      subModule: "hyperLinkPopUp",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        name: data?.field_hyperlink_name_en,
        id: editFaq?.[0]?.id || FaqById?.payload?.id,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingFaq}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Hyperlink`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingFaq || drilldownLoading}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get('editId') || query.get('type')==='update'? `${magpHost}/api/hyper-link-popup-api/${editFaq?.[0]?.id || FaqById?.payload?.id}`: `${magpHost}/api/create/hyper-link-popup-api`}`, // ${magpHost}/api/faq-details${editFaq?.id ? `/${editFaq?.[0]?.id}` : ""}
            `${query.get("editId") || query.get('type')==='update' ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get('type')==='update' ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
